<app-alerts />

@if (form$ | async; as form) {
  <app-admin-banner-details-form
    [allowedLocations]="allowedLocations()"
    [fixedLocation]="location()"
    [isEditContext]="true"
    (submitClickEvent)="handleSubmitClickEvent($event)"
    [data]="form" />
} @else {
  <app-spinner-filled />
}
